module.exports = __webpack_public_path__ + "static/media/top-hero-image@2x_.8bc5bb57.png";